import { useMemo, useState } from 'react';

import { ListCardGroup } from 'components/list-card-group';
import { ProductCard } from 'components/product-card';
import { useMenuCalories } from 'hooks/menu/use-menu-calories';
import { useUnifiedMenuContext } from 'state/unified-menu';
import { ILocalizedMenuEntry } from 'state/unified-menu/types';
import { useMenuQueryOptions } from 'state/unified-menu/use-menu-query-options';
import { getEntryPrice, stringifySanityImage } from 'state/unified-menu/utils';

import { useProductWizardContext } from '../../product-wizard';
import { DEFAULT_SLOT_KEY } from '../../product-wizard/types';
import { useProductWizardFlow } from '../../product-wizard/use-product-wizard-flow';
import { SelectorContainer } from '../styled';

import { ProductCustomizationModifiers } from './product-customization-modifiers';
import { CustomizationRenderItem } from './types';
import { getComboSlotItems } from './utils';

export const ProductCustomizationSides = () => {
  const { indexedMenu } = useUnifiedMenuContext();
  const { currentFlowStep } = useProductWizardFlow();
  const { slotsSelections, selectComboSlotItem } = useProductWizardContext();
  const menuQueryOptions = useMenuQueryOptions();
  const { formatCalories } = useMenuCalories();

  const slotKey = currentFlowStep.slotKey!;
  const selectedSlot = slotsSelections[slotKey];

  const [selectedRow, setSelectedRow] = useState<number>();

  const comboSides: ILocalizedMenuEntry[] = useMemo(
    () =>
      slotKey === DEFAULT_SLOT_KEY
        ? []
        : getComboSlotItems(indexedMenu, slotKey, menuQueryOptions.posServiceMode),
    [indexedMenu, slotKey, menuQueryOptions.posServiceMode]
  );

  if (comboSides.length < 2) {
    return null;
  }

  return (
    <SelectorContainer>
      <ListCardGroup
        items={comboSides}
        selectedRow={selectedRow}
        ItemCustomizationComponent={<ProductCustomizationModifiers />}
        renderItem={({ item, index, rowIndex }: CustomizationRenderItem) => (
          <ProductCard
            key={`side-${item.id}-${index}`}
            isSelected={item.id === selectedSlot?.itemId}
            productProps={{
              name: item.name?.locale,
              price: getEntryPrice(item, menuQueryOptions.posServiceMode),
              calories: formatCalories(item.nutrition?.calories?.def),
              image: stringifySanityImage(item.image),
            }}
            onProductPress={() => {
              selectComboSlotItem(slotKey, item.id);
              setSelectedRow(rowIndex);
            }}
          />
        )}
      />
    </SelectorContainer>
  );
};
